<template>

  <b-card-actions
    ref="list"
    title=""
    action-refresh
    @refresh="refresh"
  >

    <div class="m-1">

      <!-- Table Top -->
      <b-row class="mb-4">

        <!-- Per Page -->
        <b-col
          cols="2"
          md="1"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <export-excel
            :data="employeesForExport"
            :columns="excel_columns"
            :file-name="'employees_list'"
            :file-type="'xlsx'"
            :sheet-name="'sheetname'"
          >
            <feather-icon icon="DownloadIcon" />
          </export-excel>
        </b-col>
        <b-col
          cols="4"
          md="2"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="primary"
            class="button-inline-spacing-2"
            :disabled="editDisabled"
            @click="add_employee()"
          >
            <span class="text-nowrap">{{ $t("Add") }}</span>
          </b-button>
        </b-col>
        <b-col
          cols="4"
          md="2"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="primary"
            class="button-inline-spacing-2"
            :disabled="editDisabled"
            @click="import_bulk()"
          >
            <span class="text-nowrap">{{ $t("Import") }}</span>
          </b-button>
        </b-col>

        <b-col
          cols="4"
          md="2"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="primary"
            class="button-inline-spacing-2"
            :disabled="editDisabled"
            @click="download_courses_report()"
          >
            <span class="text-nowrap">{{ $t("Courses Report") }}</span>
          </b-button>
        </b-col>
        <b-col
          cols="4"
          md="2"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="primary"
            class="button-inline-spacing-2"
            :disabled="editDisabled"
            @click="download_medical_report()"
          >
            <span class="text-nowrap">{{ $t("Medical Report") }}</span>
          </b-button>
        </b-col>

        <b-col
          cols="4"
          md="2"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            v-if="isAdmin"
            variant="danger"
            class="button-inline-spacing-2"
            :disabled="editDisabled"
            @click="delete_all()"
          >
            <span class="text-nowrap">{{ $t("Delete all") }}</span>
          </b-button>
        </b-col>

      </b-row>

      <b-row class="mb-3">

        <!-- Per Page -->
        <b-col
          cols="12"
          md="4"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        />
        <b-col
          cols="3"
          md="4"
        >
          <b-form-checkbox
            id="terminated"
            v-model="show_terminated"
            name="terminated"
            switch
            inline
            class="mt-06 custom-control-danger"
          >
            {{ terminated_label }}
          </b-form-checkbox>
        </b-col>
        <!-- Search -->
        <b-col
          cols="9"
          md="4"
        >

          <b-form-input
            v-model="searchTerm"
            :placeholder="$t('message.SearchPlaceholder')"
            type="text"
            class="d-inline-block"
          />
        </b-col>
      </b-row>

    </div>

    <!-- alert -->
    <!--b-alert
      variant="primary"
      show
    >
      <div class="alert-body">
      </div>
    </b-alert-->

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end" />

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >

      <!-- Slot: Table Column -->
      <template
        slot="table-column"
        slot-scope="props"
      >

        <span>
          {{ $t(props.column.label) }}
        </span>
      </template>

      <!-- Slot: Table Row -->
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Photo -->
        <span
          v-if="props.column.field === 'photo'"
          class="text-nowrap v-align-middle"
        >
          <span><img
            :src="props.row.photo"
            class="mr-8 rounded h-24 w-24 profile-pic-list"
          ></span>
        </span>
        <!-- Column: Last Name -->
        <span
          v-else-if="props.column.field === 'last_name'"
          class="text-nowrap align-middle"
        >
          <span>{{ props.row.last_name }}</span>

        </span>
        <!-- Column: First Name -->
        <span
          v-if="props.column.field === 'first_name'"
          class="text-nowrap v-align-middle"
        >
          <span>{{ props.row.first_name }}</span>
        </span>

        <!-- Column: Employee Id -->
        <span
          v-else-if="props.column.field === 'role'"
          class="text-nowrap align-middle"
        >
          <span>{{ props.row.employee_role ? props.row.employee_role.name : "" }}</span>

        </span>
        <!-- Column: Employee Id -->
        <span
          v-else-if="props.column.field === 'department'"
          class="text-nowrap align-middle"
        >
          <span>{{ props.row.employee_department ? props.row.employee_department.name : "" }}</span>

        </span>

        <!-- Column: Assignments -->
        <span
          v-else-if="props.column.field === 'assignments'"
          class="text-nowrap align-middle"
        >
          <span>{{ props.row.employee_assignments }}</span>

        </span>

        <!-- Column: Action -->
        <span
          v-else-if="props.column.field === 'action'"
          class="button-inline-spacing"
        >

          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="btn-icon"
            @click="edit(props.row.id)"
          >
            <feather-icon icon="Edit2Icon" />
          </b-button>

          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="btn-icon"
            :disabled="editDisabled"
            @click="deleteEmployee(props.row)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>

        </span>

        <span
          v-else
          class="text-nowrap align-middle"
        />
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >

        <div class="d-flex justify-content-between flex-wrap">

          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{ $t('message.pagelength') }}
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10','15']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{ $t('message.pageText2') }} </span>
          </div>
          <div>

            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>

            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

  </b-card-actions>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BCardActions } from '@core/components/b-card-actions'
import {
  BAlert, BAvatar, BBadge, BButton, BCol, BDropdown, BDropdownItem, BFormCheckbox, BFormGroup, BFormInput, BFormSelect, BPagination, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import EmployeeService from '@/basic/employeeService'
import Ripple from 'vue-ripple-directive'
import ExportExcel from '@/views/components/excel-export/ExportExcel'

import Vue from 'vue'
import i18n from '@/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import ability from '@/libs/acl/ability'
import { environment } from '@/auth/environment'
import { withAuthToken } from '@/auth/utils'
import { codeI18n } from './code'

Vue.use(ExportExcel)

export default {
  components: {
    BCardCode,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BButton,
    BRow,
    BCol,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageLength: 15,
      codeI18n,
      dir: false,
      userData: JSON.parse(localStorage.getItem('userData')),
      editDisabled: !ability.can('manage', 'Basic HR'),
      columns: [
        {
          label: 'Photo',
          field: 'photo',
        },
        {
          label: 'Last Name',
          field: 'last_name',
        },
        {
          label: 'First Name',
          field: 'first_name',
        },

        {
          label: 'Department',
          field: 'department',
        },
        {
          label: 'Role',
          field: 'role',
        },
        {
          label: 'Assignments',
          field: 'assignments',
        },

        {
          label: 'action',
          field: 'action',
        },

      ],
      excel_columns: [
        {
          label: i18n.t('Last Name'),
          field: 'last_name',
        },
        {
          label: i18n.t('First Name'),
          field: 'first_name',
        },
        {
          label: i18n.t('Department'),
          field: 'department',
        },
        {
          label: i18n.t('Role'),
          field: 'role',
        },
        {
          label: i18n.t('Assignments'),
          field: 'assignments',
        },

      ],
      rows: [],
      terminated_employees: [],
      employees: [],
      searchTerm: '',
      show_terminated: false,
      terminated_label: i18n.t('Show terminated employee'),

    }
  },
  computed: {
    employeesForExport() {
      // Transform employees data for Excel export
      return this.employees.map(employee => ({
        ...employee,
        department: employee.employee_department ? employee.employee_department.name : '',
        role: employee.employee_role ? employee.employee_role.name : '',
        assignments: employee.employee_assignments || '',
      }))
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    isAdmin() {
      return this.userData && this.userData.role === 'admin'
    },

    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    show_terminated: {
      handler(newValue) {
        console.log(`watch show_terminated:${newValue}`)
        if (newValue) {
          console.log('terminated_employees', this.terminated_employees)

          this.rows = this.terminated_employees
        } else {
          console.log('employees', this.employees)
          this.rows = this.employees
        }
        console.log(this.rows)
      },
      immediate: true,
    },
  },
  mounted() {
    this.$refs.list.showLoading = true

    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === 'selected_company') {
        const id = state.userCompany && state.userCompany.id
        console.log(`Updating selected_company to ${id}`)
        if (id) this.refresh()
      }
    })

    this.refresh()
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    /**
     * Resolve company id: Vuex first, then localStorage rehydrate, then userData.company.
     * SPA login used to set only localStorage — store stayed null and crashed on .id.
     */
    resolveCompanyId() {
      let company = store.state.userCompany
      if (company && company.id) return company.id

      try {
        company = JSON.parse(localStorage.getItem('userCompany'))
      } catch (e) {
        company = null
      }
      if (company && company.id) {
        store.commit('selected_company', company)
        return company.id
      }

      try {
        const userData = JSON.parse(localStorage.getItem('userData'))
        company = userData && userData.company
      } catch (e) {
        company = null
      }
      if (company && company.id) {
        store.commit('selected_company', company)
        localStorage.setItem('userCompany', JSON.stringify(company))
        return company.id
      }
      return null
    },
    refresh() {
      console.log('refresh')
      this.$refs.list.showLoading = true

      const company_id = this.resolveCompanyId()
      if (!company_id) {
        console.warn('EmployeesList: no userCompany — skip load')
        this.rows = []
        this.$refs.list.showLoading = false
        return
      }
      const employeeService = new EmployeeService(useJwt)

      employeeService.employees(company_id, {}).then(response => {
        this.employees = response.data.data.employees
        this.terminated_employees = response.data.data.terminated_employees

        if (this.show_terminated) {
          this.rows = this.terminated_employees
        } else {
          this.rows = this.employees
        }
        console.log('rows', this.rows)
        this.$refs.list.showLoading = false
      }).catch(err => {
        console.error('EmployeesList refresh failed', err)
        this.$refs.list.showLoading = false
      })
    },
    download_medical_report() {
      const company_id = this.resolveCompanyId()
      if (!company_id) return

      const link = document.createElement('a')

      link.href = withAuthToken(`${environment.baseURL}/dashboard/downloadMedicalReport/${company_id}/all`)
      link.download = 'report_scadenze.pdf'
      link.click()
      URL.revokeObjectURL(link.href)
    },

    download_courses_report() {
      const company_id = this.resolveCompanyId()
      if (!company_id) return

      const link = document.createElement('a')

      link.href = withAuthToken(`${environment.baseURL}/dashboard/downloadCoursesReport/${company_id}/all`)
      link.download = 'report_scadenze.pdf'
      link.click()
      URL.revokeObjectURL(link.href)
    },

    add_employee() {
      this.$router.push({ name: 'employee', params: { id: 'new' } })
    },
    import_bulk() {
      this.$router.push({ name: 'import-employees', params: {} })
    },

    edit(id) {
      this.$router.push({ name: 'employee', params: { id } })
    },
    delete_all() {
      console.log('delete all employees')
      let confirmed = false
      const message = `${i18n.t('You are deleting all the employees')}. ${i18n.t('Are you sure?')}`

      this.$bvModal
        .msgBoxConfirm(message, {
          title: i18n.t('Confirmation Required'),
          size: 'sm',
          okVariant: 'primary',
          okTitle: i18n.t('Proceed'),
          cancelTitle: i18n.t('Cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          confirmed = value

          if (confirmed) {
            const employeeService = new EmployeeService(useJwt)
            const company_id = this.resolveCompanyId()
            if (!company_id) return

            employeeService.delete_all_employees(company_id).then(response => {
              if (response.data.status === 'success') {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: i18n.t('Employees deleted'),
                    icon: 'AlertIcon',
                    variant: 'success',
                    text: i18n.t('Employees deleted with success'),
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: i18n.t('Employees not deleted'),
                    icon: 'AlertIcon',
                    variant: 'danger',
                    text: i18n.t(response.data.message),
                  },
                })
              }

              this.refresh()
            })
          }
        })
    },
    deleteEmployee(row) {
      console.log('delete')
      let confirmed = false
      const message = `${i18n.t('You are deleting the employee')}: "${row.first_name} ${row.last_name}". ${i18n.t('Are you sure?')}`

      this.$bvModal
        .msgBoxConfirm(message, {
          title: i18n.t('Confirmation Required'),
          size: 'sm',
          okVariant: 'primary',
          okTitle: i18n.t('Proceed'),
          cancelTitle: i18n.t('Cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          confirmed = value

          if (confirmed) {
            const employeeService = new EmployeeService(useJwt)
            employeeService.delete_employee(row.id).then(response => {
              if (response.data.status === 'success') {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: i18n.t('Employee deleted'),
                    icon: 'AlertIcon',
                    variant: 'success',
                    text: i18n.t('Employee deleted with success'),
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: i18n.t('Employee not deleted'),
                    icon: 'AlertIcon',
                    variant: 'danger',
                    text: i18n.t(response.data.message),
                  },
                })
              }

              this.refresh()
            })
          }
        })
    },
    list_documents(id) {
      this.$router.push({ name: 'documents', params: { document_section_id: id } })
    },
  },
}
</script>
